import { useRef, useEffect, useCallback } from "react";

export default function useUpdateEffect(callback, dependencies) {
    const ref = useRef(false);

    const effect = useCallback(callback, dependencies);
    
    useEffect(() => {
        if (ref.current) {
            return effect();
        }
        ref.current = true;
    }, [effect]);

    return null;
}